import { Component, OnDestroy, OnInit } from '@angular/core';
import { WelcomeContinueService } from '../welcome-continue.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { takeWhile } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../common/services/auth.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-activate-mfa',
  templateUrl: './activate-mfa.component.html',
  standalone: true,
  imports: [NgIf, FormsModule, FaIconComponent]
})
export class ActivateMfaComponent implements OnInit, OnDestroy {
  private alive: boolean;
  public loginEmail: string;
  public loginPassword: string;
  backend: string;
  partialToken: string;
  mfaVerify: string;

  constructor(
    public stateService: WelcomeContinueService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private toastService: ToastrService
  ) {}

  ngOnInit() {
    this.alive = true;
    this.stateService.setTitleText('Verify Your MFA Code');
    this.route.queryParamMap.pipe(takeWhile(() => this.alive)).subscribe((params: ParamMap) => {
      if (params.has('e')) {
        const msg =
          this.authService.authErrorMessages[params.get('e')] || 'There was a problem verifying your nickname.';
        // https://github.com/scttcper/ngx-toastr#faq
        setTimeout(() => this.toastService.error(msg, 'Verification Error'));
      }
      if (params.has('backend') && params.has('partialToken')) {
        this.backend = params.get('backend');
        this.partialToken = params.get('partialToken');
      } else {
        setTimeout(() => this.toastService.error('Something went wrong.', 'Contact Support'));
        console.error(`ERROR: "backend" and "partialToken" are required query parameters.`);
      }
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
